var jQuery = require('jquery');
var jqueryDatepicker = require('jquery-datepicker');
require('jquery-datepicker/i18n/jquery.ui.datepicker-ja');
var validate = require('jquery-validation');
require('magnific-popup');

(function ($) {
  // Init jquery datepicker
  jqueryDatepicker($);

  // Initialize vars
  var APP_KEY = 'n5VUcCauqEZG61bY1JS6UDxXcPsXdhawdiVagvPBzhm9bTFctPjjqnR9NCUnxYDf',
    product, product_id, output;

  /* Helpers */

  // Wordwrap
  function wordwrap(str, width, brk, cut) 
  {

    brk = brk || 'n';
    width = width || 75;
    cut = cut || false;

    if (!str) { return str; }

    var regex = '.{1,' +width+ '}(\s|$)' + (cut ? '|.{' +width+ '}|.+$' : '|\S+?(\s|$)');

    return str.match( new RegExp(regex, 'g') ).join( brk );
  }

  // Match Words
  function matchWords(subject, words) {
    var regexMetachars = /[(){[*+?.\\^$|]/g;

    for (var i = 0; i < words.length; i++) {
      words[i] = words[i].replace(regexMetachars, "\\$&");
    }

    var regex = new RegExp("\\b(?:" + words.join("|") + ")\\b", "gi");

    return subject.match(regex) || false;
  }

  // Get Query Parameter
  function getQueryParam(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] === variable){return pair[1];}
    }
    return(false);
  }

  $(document).ready(function() {

    // Once page is complete fade out loading
    $(".loading").fadeOut();

    // Jquery Validate : Access Order form
    if ( $("article").hasClass('orderPage') )
    {
      $("#formOrderId").validate({
        // Turn off error messages
        errorPlacement: function(error,element) {
          return true;
        }
      });
    }

    // Send Ecard page
    if ( $("article").hasClass('sendEcardPage') )
    {
      // Form validation
      $("#formSendEcard").validate({
        // Turn off error messages
        errorPlacement: function(error,element) {
          return true;
        }
      });

      // Datepicker
      $( "#send_time" ).datepicker({minDate: 0});

      // Enable / Disable send time input
      $( "#schedule_to_sent" ).on('click', function() {
         $("#send_time").attr('disabled', !this.checked);
      }); 

      $('textarea').keypress(function(e) {
        var tval = $('textarea').val(),
          tlength = tval.length,
          set = 400,
          remain = parseInt(set - tlength);
        $('p.messageDesc').text(remain + ' characters left');
        if (remain <= 0 && e.which !== 0 && e.charCode !== 0) {
          $('textarea').val((tval).substring(0, tlength - 1))
        }
      });
    }

    // Initialize Preview Popup
    $('.mfp-preview-popup').magnificPopup({
      closeBtnInside: true,
      removalDelay: 500, //delay removal by X to allow out-animation
      type:'inline',
      midClick: true,
      mainClass: 'mfp-fade',
      callbacks: {
        beforeOpen: function() 
        {
          // Get effect
          // this.st.mainClass = this.st.el.attr('data-effect');
          //$("#ecardMessage").html( wordwrap( $("#message").val(), 60, '<br />' ) );
          $("#ecardMessage").html( $("#message").val() );
          var fullName, firstName, lastName;
          firstName = $("#first_name").val();
          lastName = $("#last_name").val();
          fullName = firstName + ' ' + lastName;
          $("#senderName").html( fullName.trim() );
        }
      }
    });

  });

}(jQuery));